import { removeDeviceInDeviceTree } from '../../redux/devices/tree/actions';
import { openErrorDialog, } from '../../dialogs/error/redux/actions';
export const openDeleteDialog = () => ({
    type: 'DELETE_DIALOG__OPEN',
});
export const closeDeleteDialog = () => ({
    type: 'DELETE_DIALOG__CLOSE',
});
export const deleteDevice = (delete_device_id, clear_data) => async (dispatch, getState, { api }) => {
    dispatch({
        type: 'DELETE_DEVICE__REQUEST',
        delete_device_id,
        clear_data,
    });
    try {
        await api.delete_device(delete_device_id, clear_data);
        const selected_id = getState().devices.selected_id;
        dispatch({
            type: 'DELETE_DEVICE__OK',
            delete_device_id,
            clear_data,
        });
        //Удаляем устройства из дерева групп
        dispatch(removeDeviceInDeviceTree(delete_device_id));
    }
    catch (error) {
        dispatch({
            type: 'DELETE_DEVICE__FAIL',
            delete_device_id,
            clear_data,
            error: error?.json?.error_ui ??
                error?.json?.error ??
                'Не удалось отправить запрос',
        });
        dispatch(openErrorDialog({
            error,
            error_ui: error?.json?.error_ui ?? 'Не удалось отправить запрос',
        }));
    }
};
